import { Button, HeaderSection, Icon } from '@lmc/ui-kit'
import { useAbilityAccess } from 'components/AccessControl'
import { ProTag } from 'components/ProTag'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type Props = {
  handleToggleModal: () => void
  residentName: string | undefined
  residentFirstName: string | undefined
  carePlanNominative: string | undefined
  testId?: string
}

export const ResidentNeedsHeaderSection: FC<Props> = ({
  handleToggleModal,
  residentName,
  residentFirstName,
  carePlanNominative,
  testId
}) => {
  const { t } = useTranslation()
  const canManageNeeds = useAbilityAccess([
    { i: 'create', this: 'ResidentNeed' }
  ])

  const title = residentName
    ? `${residentName}'s ${t('skillsAndNeeds.needs')}`
    : t('skillsAndNeeds.needs')

  return (
    <StyledHeaderWrapper
      data-testid={
        testId ? `${testId}-needs-header-section` : 'needs-header-section'
      }
    >
      <HeaderSection
        title={
          <TitleContainer>
            {title} <ProTag />
          </TitleContainer>
        }
        subtitle={t('skillsAndNeeds.residentNeedsSubtitle', {
          firstName: residentFirstName,
          carePlans: carePlanNominative
        })}
        subtitleStyle={{ marginTop: 8 }}
        rightChildren={
          canManageNeeds ? (
            <Button
              onClick={handleToggleModal}
              icon={<Icon name="PlusOutlined" />}
              variant="primary"
              data-testid={
                testId ? `${testId}-needs-add-button` : 'needs-add-button'
              }
            >
              {t('skillsAndNeeds.assignNewNeedButton')}
            </Button>
          ) : undefined
        }
        testId={testId ? `${testId}-needs-page-header` : 'needs-page-header'}
      />
    </StyledHeaderWrapper>
  )
}

export default ResidentNeedsHeaderSection

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`

const StyledHeaderWrapper = styled.div`
  margin-bottom: 10px;

  [data-testid='header-section'] > .ant-row > div {
    flex-wrap: nowrap !important;
    padding: 20px 28px !important;
  }

  [data-testid='header-section-right-children'] {
    margin-left: 40px;
    flex-shrink: 0;
  }

  [data-testid='header-section-title-container'] {
    min-width: 0;
  }

  [data-testid='header-section-subtitle'] {
    white-space: normal;
    word-break: break-word;
  }
`
